<script setup>
import FAQItem from '@/components/ui/FAQItem.vue'

/**
 * LandingFAQ V3 - Accordion Design
 *
 * Migrated from public/prototypes/landing-v3-storytelling.html
 * Native <details> accordion with honest answers
 */

const faqs = [
  {
    question: '¿Que es el derecho al olvido segun GDPR?',
    answer: 'El derecho al olvido (GDPR Art. 17) es el derecho de las personas a solicitar la eliminacion de sus datos personales cuando ya no son necesarios para el fin por el que fueron recopilados, cuando se retira el consentimiento, o cuando los datos fueron tratados ilicitamente.',
    open: true
  },
  {
    question: '¿Cuanto tarda realmente el proceso?',
    answer: 'El proceso completo suele tardar entre 30 y 60 dias, aunque puede extenderse hasta 90 dias en casos complejos. Por ley (GDPR Art. 12), las empresas tienen hasta 1 mes para responder. Nuestro analisis de viabilidad inicial tarda 72 horas habiles.',
    open: false
  },
  {
    question: '¿Garantizais la eliminacion?',
    answer: 'Garantizamos una gestion profesional experta. Realizamos un filtro previo para asegurar que tu caso es viable antes de contratar. Sin embargo, la eliminacion definitiva depende de criterios legales y de terceros ajenos a nuestra firma. Los honorarios cubren el servicio de analisis, preparacion y envio de las solicitudes legales y seguimiento, por lo que no se contempla el reembolso si la plataforma deniega la peticion por causas legales justificadas.',
    open: false
  },
  {
    question: '¿Que pasa si mi solicitud es rechazada?',
    answer: 'Si una plataforma rechaza tu solicitud y consideramos que es injustificado segun GDPR, escalaremos a la Agencia Espanola de Proteccion de Datos (AEPD) sin coste adicional.',
    open: false
  },
  {
    question: '¿Son pagos unicos o hay suscripcion?',
    answer: 'Todos nuestros planes son de <strong>pago unico</strong>. No hay suscripciones, ni pagos recurrentes, ni cargos ocultos. Pagas una vez y gestionamos tu caso hasta su resolucion.',
    open: false
  }
]
</script>

<template>
  <section id="faq" class="py-24 bg-white">
    <div class="max-w-3xl mx-auto px-6">
      <!-- Section Header -->
      <div class="text-center mb-16">
        <span class="text-sm font-semibold text-accent-600 uppercase tracking-widest mb-4 block">FAQ</span>
        <h2 class="text-4xl md:text-5xl font-bold text-text-primary">
          Respuestas honestas
        </h2>
      </div>

      <!-- FAQ Items -->
      <div class="space-y-4">
        <FAQItem
          v-for="(faq, index) in faqs"
          :key="index"
          :question="faq.question"
          :answer="faq.answer"
          :open="faq.open"
        />
      </div>
    </div>
  </section>
</template>
